<template>
  <component
    :is="item.bannerLink ? VisionLink : 'div'"
    :is-button="item.bannerLink?.startsWith('@modal:')"
    :href="resolveLocalePath(item.bannerLink)"
    :class="bem({ hasStructuredContent: item.content })"
    @click="handleLinkClick"
  >
    <DatoCmsImage
      v-if="item.backgroundImage"
      :class="bem('background-image', { desktop: true, mobile: !item.mobileBackgroundImage })"
      :data="item.backgroundImage.responsiveImage"
      layout="fill"
      :object-fit="item.backgroundMode"
      :object-position="`${item.backgroundImage.focalPoint.x * 100}% ${
        item.backgroundImage.focalPoint.y * 100
      }%`"
      sizes="(max-width: 600px) 420px, 800px"
    />

    <DatoCmsImage
      v-if="item.mobileBackgroundImage"
      :class="bem('background-image', { mobile: true })"
      :data="item.mobileBackgroundImage.responsiveImage"
      layout="fill"
      :object-fit="item.mobileBackgroundMode"
      :object-position="`${item.mobileBackgroundImage.focalPoint.x * 100}% ${
        item.mobileBackgroundImage.focalPoint.y * 100
      }%`"
      sizes="(max-width: 600px) 420px, 800px"
    />

    <div
      class="FilterBannerGeneric__content"
    >
      <div
        v-if="item.content"
        class="FilterBannerGeneric__structured-content"
      >
        <GenericStructuredText
          :content="item.content"
          copy-size="body-sm"
          cta-size="x-small"
          :has-parent-wrapping-link="!!item.bannerLink"
          @button-click="handleTracking"
        />
      </div>
    </div>
  </component>
</template>

<script setup>
import { Image as DatoCmsImage } from 'vue-datocms'
import { VisionLink } from '#components';

const { resolveLocalePath } = useUrlBuilder()

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
    required: true,
  },
})

const bem = useBEM('FilterBannerGeneric')
const { $track } = useNuxtApp()
const modalStore = useModalStore()

async function handleLinkClick() {
  if (props.item.bannerLink?.startsWith('@modal:')) {
    const modalId = props.item.bannerLink.split('@modal:')[1]
    modalStore.OPEN_MODAL_PAGE({ slug: modalId })
  }

  await handleTracking()
}

async function handleTracking() {
  await $track.global.linkClicked({
    interactionElement: props.item.slug,
    interactionSection: 'Filter results',
    interactionCategory: 'Filter banner'
  }, 'Clicked Inline Filter Banner')
}


</script>

<style lang="postcss">
.FilterBannerGeneric {
  @apply w-full;
}

.FilterBannerGeneric__content {
  @apply relative p-4 w-full flex flex-col mt-[12%];

  @screen sm {
    @apply mt-[20%];
  }
  
  @screen md {
    @apply py-10 px-6;
  }

  @screen xl {
    @apply p-10;
  }

  .FilterBannerGeneric--has-structured-content & {
    @apply mt-0 w-full h-full p-xs md:py-7 md:px-xs;
  }
}

.FilterBannerGeneric--has-structured-content {
  @apply h-full w-full items-stretch;

  > .VisionLink__text {
    @apply w-full;
  }
}

.FilterBannerGeneric__structured-content {
  @apply w-full h-full flex flex-col;

  h1, h2 {
    &.GenericStructuredText__title-block,
    &.GenericStructuredText__heading {
      @screen smMax {
        @apply heading-3 mb-1;
      }
    }
  }

  .t-body-sm {
    @apply text-[11px] md:text-base;
  }

  .VisionButton__text {
    @apply smMax:text-[11px];
  }
}

.FilterBannerGeneric__background-image {
  &--desktop {
    @apply mdMax:!hidden md:block;

    &.FilterBannerGeneric__background-image--mobile {
      @apply mdMax:!block md:!block;
    }
  }

  &--mobile {
    @apply mdMax:block md:!hidden;
  }
}
</style>
